import React from "react";
import { PuffLoader } from "react-spinners";
import ModalTitle from "../common/ModalTitle";
import ModalCloseButton from "../common/ModalCloseButton";
import ModalDecorations from "./ModalDecorations";
import FieldRenderer from "./FieldRenderer";
import ModalDialog from "../common/ModalDialog";
import ModalContent from "../common/ModalContent";
import ModalHeader from "../common/ModalHeader";
import ModalBody from "../common/ModalBody";
import ModalFooter from "../common/ModalFooter";
import ModalButton from "../common/ModalButton";

export default function ForgotPasswordForm({
  inputFields,
  modalType,
  handleInputChange,
  handleForgotPassword,
  forgotPassLoading,
  setForgotPassOptions,
  setErrors,
  handleCloseModal,
}) {
  const isTyped = inputFields.forgotPassFields.every(field => field.value.trim() !== "");
  return (
    // <div className="modal-dialog brand-modal-dialog tw-mt-0">
    <ModalDialog>
      {/* <div className="modal-content forgotPasswordContent 
      tw-relative tw-h-[100vh] sm:tw-h-full
      tw-p-0 sm:tw-p-[20px]
      "> */}
      <ModalContent className="sm:tw-p-[20px]">
        {/* <div className="modal-header brand-header justify-content-center"> */}
        <ModalHeader className="tw-border-none">
          <ModalTitle text={"Recover your Password"} />
          {/* <div className="">
             <h5 className="modal-title text-center">Recover your Password</h5> 
            
          
          </div> */}
          <p className="---modalSubTitle ---text-center
          tw-text-[#818383] tw-font-['Raleway'] tw-text-[14px] sm:tw-text-[18px] tw-font-normal tw-leading-[34px] tw-tracking-[0em] sm:tw-text-center">
            <span style={{ color: "black" }}>
              Enter the email
            </span>{" "}
            that you used when register to recover your
            password. You will receive a{" "}
            <span style={{ color: "black" }}>
              {" "}
              password reset link.
            </span>
          </p>
          <ModalCloseButton
            id={"forgotPass-modal-close"}
            onClose={() => {
              setForgotPassOptions(false);
              setErrors([]);
              handleCloseModal();
            }}
          />
        </ModalHeader>

        <ModalBody>
          {/* Decorations */}
          <ModalDecorations />

          {/* Input fields */}
          <div className="tw-w-full">
            {/* {inputFields.forgotPassFields.map((field) => (
              <div className="mb-2 position-relative" key={`forgot-pass-${field.key}`}>
                <input
                  type={field.type}
                  name={field.key}
                  value={field.value}
                  className="form-control brand-field"
                  placeholder={field.placeholder}
                  onChange={(e) => handleInputChange(e, modalType)}
                  onKeyUp={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleForgotPassword(modalType);
                    }
                  }}
                />
                {field.error && <small className="ms-4 text-danger">{field.error}</small>}
              </div>
            ))} */}

            {inputFields.forgotPassFields.map((field, index) => (
              // <div className="mb-2 position-relative" key={`login-${field.key}-${index}`}>
              <FieldRenderer
                key={`login-${field.key}-${index}`}
                className="tw-mb-2 md:tw-mb-0 tw-relative"
                field={field}
                handleInputChange={handleInputChange}
                handlePress={handleForgotPassword} // dùng chung
                modalType={modalType}
                // showPassword={showPassword}
                // setShowPassword={setShowPassword}
                // showConfirmPassword={showConfirmPassword}
                // setShowConfirmPassword={setShowConfirmPassword}
                withLabel={true} // để render label + required giống code cũ
              />
              // </div>
            ))}

          </div>
        </ModalBody>

        <ModalFooter>
          {/* {forgotPassLoading ? (
            <PuffLoader color="#65acae" size={42} />
          ) : (
            <button
              onClick={() => handleForgotPassword(modalType)}
              className="btn common-button-style-filled signup-btn me-sm-4 border-0"
              disabled={forgotPassLoading}
            >
              Send Link
            </button>
          )} */}



          <ModalButton
            className="sm:tw-m-auto"
            label=" Send Link"
            onClick={() => handleForgotPassword(modalType)}
            loading={forgotPassLoading}
            disabled={!isTyped || forgotPassLoading}
          />
        </ModalFooter>
      </ModalContent>
    </ModalDialog>
  );
}
